import React from 'react';
import { formatPrice } from '../../../../utils';
import SettingsSaveButton from '../SettingsSaveButton';
import MotorCurrencySelect from '../MotorCurrencySelect';

const KatlamaliSettings = React.memo(({
  katlamaliExtras,
  setKatlamaliExtras,
  isKatlamaliMekanizmaCollapsed,
  setIsKatlamaliMekanizmaCollapsed,
  newKatlamaliMekanizma,
  setNewKatlamaliMekanizma,
  handleSaveSettings,
  isSavingSettings
}) => {
  const [editingId, setEditingId] = React.useState(null);

  const handleAddOrUpdate = () => {
    if (!newKatlamaliMekanizma.type.trim() || !newKatlamaliMekanizma.price) return;

    const currentList = katlamaliExtras.mekanizmaList || [];
    let newList;

    if (editingId) {
      newList = currentList.map(m => m.id === editingId ? {
        ...m,
        type: newKatlamaliMekanizma.type.trim(),
        price: parseFloat(newKatlamaliMekanizma.price)
      } : m);
    } else {
      newList = [...currentList, {
        id: Date.now().toString(),
        type: newKatlamaliMekanizma.type.trim(),
        price: parseFloat(newKatlamaliMekanizma.price)
      }];
    }

    setKatlamaliExtras({ ...katlamaliExtras, mekanizmaList: newList });
    handleSaveSettings({ katlamaliMekanizmaList: newList });
    setNewKatlamaliMekanizma({ type: '', price: '' });
    setEditingId(null);
  };

  return (
    <>
      <div className="settings-card">
        <div className="settings-card-header">
          <div className="settings-card-title">
            <i className="fas fa-cogs"></i>
            <div className="settings-card-title-text">
              <h4>Motor Ayarları</h4>
              <span className="settings-card-subtitle">Motor döviz kuru ve ücret bilgileri</span>
            </div>
          </div>
          <SettingsSaveButton
            onClick={() => handleSaveSettings()}
            isSaving={isSavingSettings}
          />
        </div>

        <div className="settings-fields-grid settings-fields-grid--compact">
          <div className="form-group">
            <label>Motor Döviz Kuru</label>
            <MotorCurrencySelect
              value={katlamaliExtras.motorCurrency}
              onChange={(currency) => setKatlamaliExtras(p => ({ ...p, motorCurrency: currency }))}
            />
          </div>
          <div className="form-group">
            <label>Motor Ücreti</label>
            <div className="settings-input-wrap">
              <input
                type="number"
                value={katlamaliExtras.motorPrice}
                onChange={(e) => setKatlamaliExtras(p => ({ ...p, motorPrice: e.target.value }))}
                placeholder="0"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="settings-card settings-card--accordion">
        <div
          className="settings-accordion-header"
          onClick={() => setIsKatlamaliMekanizmaCollapsed(!isKatlamaliMekanizmaCollapsed)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && setIsKatlamaliMekanizmaCollapsed(!isKatlamaliMekanizmaCollapsed)}
        >
          <div className="settings-card-title">
            <i className="fas fa-tools"></i>
            <div className="settings-card-title-text">
              <h4>Katlamalı Perde Mekanizma Ayarları</h4>
              <span className="settings-card-subtitle">Mekanizma tipleri ve ücretleri</span>
            </div>
          </div>
          <i className={`fas fa-chevron-${isKatlamaliMekanizmaCollapsed ? 'down' : 'up'} settings-accordion-chevron`}></i>
        </div>

        {!isKatlamaliMekanizmaCollapsed && (
          <div className="settings-accordion-content">
            <div className="mekanizma-add-form">
              <input
                type="text"
                placeholder="Mekanizma Tipi (Örn: 5+1)"
                value={newKatlamaliMekanizma.type}
                onChange={(e) => setNewKatlamaliMekanizma({ ...newKatlamaliMekanizma, type: e.target.value })}
              />
              <div className="settings-input-wrap settings-input-wrap--sm">
                <input
                  type="number"
                  placeholder="Ücret"
                  value={newKatlamaliMekanizma.price}
                  onChange={(e) => setNewKatlamaliMekanizma({ ...newKatlamaliMekanizma, price: e.target.value })}
                />
                <span className="settings-input-suffix">₺</span>
              </div>
              <button type="button" className="mekanizma-add-btn" onClick={handleAddOrUpdate}>
                {editingId ? 'Güncelle' : 'Ekle'}
              </button>
              {editingId && (
                <button
                  type="button"
                  className="mekanizma-cancel-btn"
                  onClick={() => {
                    setEditingId(null);
                    setNewKatlamaliMekanizma({ type: '', price: '' });
                  }}
                >
                  Vazgeç
                </button>
              )}
            </div>

            {katlamaliExtras.mekanizmaList && katlamaliExtras.mekanizmaList.length > 0 ? (
              <>
                <p className="mekanizma-list-heading">
                  <span>Kayıtlı Mekanizma Tipleri</span>
                  <span className="mekanizma-list-count">{katlamaliExtras.mekanizmaList.length}</span>
                </p>
                <ul className="mekanizma-list">
                  {katlamaliExtras.mekanizmaList.map((mek, idx) => {
                    const isEditing = editingId === mek.id;

                    return (
                      <li
                        key={mek.id}
                        className={`mekanizma-row${isEditing ? ' mekanizma-row--editing' : ''}`}
                      >
                        <div className="mekanizma-row-main">
                          <span className="mekanizma-row-index" aria-hidden="true">
                            {String(idx + 1).padStart(2, '0')}
                          </span>
                          <div className="mekanizma-row-icon" aria-hidden="true">
                            <i className="fas fa-cog"></i>
                          </div>
                          <div className="mekanizma-row-details">
                            <span className="mekanizma-row-type">{mek.type}</span>
                            {isEditing && (
                              <span className="mekanizma-row-badge">Düzenleniyor</span>
                            )}
                          </div>
                          <span className="mekanizma-row-price">{formatPrice(mek.price)} ₺</span>
                        </div>
                        <div className="mekanizma-row-actions">
                          <button
                            type="button"
                            className="mekanizma-icon-btn mekanizma-icon-btn--edit"
                            onClick={() => {
                              setEditingId(mek.id);
                              setNewKatlamaliMekanizma({ type: mek.type, price: mek.price });
                            }}
                            title="Düzenle"
                            aria-label={`${mek.type} mekanizmasını düzenle`}
                            disabled={isEditing}
                          >
                            <i className="fas fa-pen"></i>
                          </button>
                          <button
                            type="button"
                            className="mekanizma-icon-btn mekanizma-icon-btn--delete"
                            onClick={() => {
                              const newList = katlamaliExtras.mekanizmaList.filter(m => m.id !== mek.id);
                              setKatlamaliExtras({ ...katlamaliExtras, mekanizmaList: newList });
                              handleSaveSettings({ katlamaliMekanizmaList: newList });
                              if (editingId === mek.id) {
                                setEditingId(null);
                                setNewKatlamaliMekanizma({ type: '', price: '' });
                              }
                            }}
                            title="Sil"
                            aria-label={`${mek.type} mekanizmasını sil`}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </>
            ) : (
              <div className="mekanizma-empty-state">
                <i className="fas fa-tools"></i>
                <p>Henüz mekanizma tipi eklenmemiş.</p>
                <span>Yukarıdaki formu kullanarak ilk mekanizmayı ekleyebilirsiniz.</span>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
});

export default KatlamaliSettings;
